import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import { utils, writeFile } from 'xlsx';

const ListaCA = () => {
  const [datosGenerados, setDatosGenerados] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1); // Estado para la paginación
  const [registrosPorPagina] = useState(50); // Número de registros por página

  // Fetch de los datos
  const fetchData = () => {
    const datos = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321"
      },
      Usr: {
        Codigo: "",
        UserNickName: "pierril"
      },
      DatosMetodo: {
        NombreMetodo: "ListaParaDashBoardCA",
        Datos_Recibidos: ""
      }
    };

    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;

    fetch(fetchDataUrl)
      .then(response => response.json())
      .then(data => {
        const datosGeneradosDecodificados = JSON.parse(data.datos_Generados);
        console.log('Datos generados:', datosGeneradosDecodificados); // Verifica los datos recibidos
        setDatosGenerados(datosGeneradosDecodificados);
      })
      .catch(error => console.error('Error:', error));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Procesar los datos para las gráficas y tablas
  const centers = [...new Set(datosGenerados.map(record => record.NombreCentroAcopio))];

  // Filtrar los datos por estado 1 y agrupar por centro de acopio
  const recordsByCenterAndState1 = centers.map((center) => {
    const filteredRecords = datosGenerados.filter(
      (record) => record.NombreCentroAcopio === center && record.Estado === "1"
    );
  
    // Obtener el código del centro de acopio (asumiendo que todos los registros de un centro tienen el mismo código)
    const codigoCentroAcopio =
      filteredRecords.length > 0 ? filteredRecords[0].CodigoCentroAcopio : "N/A";
  
    return {
      center, // Nombre del centro de acopio
      codigoCentroAcopio, // Código del centro de acopio
      totalWeight: filteredRecords.reduce((sum, record) => sum + (record.Peso || 0), 0),
      details: filteredRecords,
    };
  });

  // Filtrar los datos por estado 2 y agrupar por centro de acopio
  const recordsByCenterAndState2 = centers.map(center => {
    const filteredRecords = datosGenerados.filter(
      record => record.NombreCentroAcopio === center && record.Estado === "2"
    );
    return {
      center,
      totalWeight: filteredRecords.reduce((sum, record) => sum + (record.Peso || 0), 0),
      details: filteredRecords
    };
  });

  console.log('Datos filtrados por estado 1 y centro de acopio:', recordsByCenterAndState1); // Verificar los datos filtrados
  console.log('Datos filtrados por estado 2 y centro de acopio:', recordsByCenterAndState2); // Verificar los datos filtrados

// Ordenar por código de centro de acopio
const sortedRecords = recordsByCenterAndState1.sort((a, b) =>
  a.codigoCentroAcopio.localeCompare(b.codigoCentroAcopio)
);

// Crear los datos para la gráfica
const state1BarChartData = {
  labels: sortedRecords.map((item) => item.center),
  datasets: [
    {
      label: "Peso por Centro de Acopio (Estado 1)",
      data: sortedRecords.map((item) => item.totalWeight),
      backgroundColor: "rgba(75, 192, 192, 0.6)",
      borderColor: "rgba(75, 192, 192, 1)",
      borderWidth: 1,
    },
  ],
};

  // Datos para la gráfica de barras (estado 2 por centro de acopio)
  const state2BarChartData = {
    labels: recordsByCenterAndState2.map(item => item.center),
    datasets: [
      {
        label: 'Peso por Centro de Acopio (Estado 2)',
        data: recordsByCenterAndState2.map(item => item.totalWeight),
        backgroundColor: 'rgba(255, 99, 132, 0.6)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1
      }
    ]
  };

  // Función para exportar los datos a Excel (estado 1)
  const exportToExcelEstado1 = () => {
    const worksheetData = recordsByCenterAndState1.flatMap(item =>
      item.details.map(detail => ({
        Centro_Acopio: item.center,
        Usuario: detail.Nombre_Usuario,
        Código_Proveedor: detail.CodProveedor,
        Nombre_Proveedor: detail.NombreProveedor,
        Observaciones: detail.Observaciones || 'N/A',
        Temperatura: detail.Temperatura + ' °F',
        Peso: detail.Peso,
        Peso_Tara: detail.PesoTara
      }))
    );

    const worksheet = utils.json_to_sheet(worksheetData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Centros de Acopio (Estado 1)");

    writeFile(workbook, 'centros_de_acopio_estado_1.xlsx');
  };

  // Función para exportar los datos a Excel (estado 2)
  const exportToExcelEstado2 = () => {
    const worksheetData = recordsByCenterAndState2.flatMap(item =>
      item.details.map(detail => ({
        Centro_Acopio: item.center,
        Usuario: detail.Nombre_Usuario,
        Código_Proveedor: detail.CodProveedor,
        Nombre_Proveedor: detail.NombreProveedor,
        Observaciones: detail.Observaciones || 'N/A',
        Temperatura: detail.Temperatura + ' °F',
        Peso: detail.Peso,
        Peso_Tara: detail.PesoTara
      }))
    );

    const worksheet = utils.json_to_sheet(worksheetData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Centros de Acopio (Estado 2)");

    writeFile(workbook, 'centros_de_acopio_estado_2.xlsx');
  };

  // Lógica para la paginación
  const indexOfLastRecord = paginaActual * registrosPorPagina;
  const indexOfFirstRecord = indexOfLastRecord - registrosPorPagina;
  const currentRecords = recordsByCenterAndState1
    .flatMap(item => item.details)
    .slice(indexOfFirstRecord, indexOfLastRecord);

  const paginate = (pageNumber) => setPaginaActual(pageNumber);

  return (
    <div>
      {/* Gráfica por Centro de Acopio (Estado 1) */}
      <div className="container mt-4">
  {/* Card para la gráfica "En Tanque" */}
  <div className="card mb-4">
    <div className="card-header bg-primary text-white">
      <h2 className="card-title mb-0">En Tanque</h2>
    </div>
    <div className="card-body">
      <Bar data={state1BarChartData} />
    </div>
  </div>

  {/* Card para la gráfica "En Camion" */}
  <div className="card mb-4">
    <div className="card-header bg-success text-white">
      <h2 className="card-title mb-0">En Camion</h2>
    </div>
    <div className="card-body">
      <Bar data={state2BarChartData} />
    </div>
  </div>
</div>
      {/* Botones para exportar a Excel */}
      <div className="container mt-4">
  {/* Botones para exportar a Excel */}
  <div className="mb-4">
    <button className="btn btn-success me-2" onClick={exportToExcelEstado1}>
      Exportar a Excel Leche En Tanque 
    </button>
   { /*<button className="btn btn-success" onClick={exportToExcelEstado2}>
      Exportar a Excel (Estado 2)
    </button>*/}
  </div> 

  {/* Tabla de detalles por Centro de Acopio (Estado 1) con paginación */}
  <h3 className="mb-3">Detalle de Leche en Tanque</h3>
  <div className="table-responsive">
    <table className="table table-bordered table-striped">
      <thead className="table-dark">
        <tr>
          <th>Centro de Acopio</th>
          <th>Usuario</th>
          <th>Código de Proveedor</th>
          <th>Nombre del Proveedor</th>
          <th>Observaciones</th>
          <th>Temperatura</th>
          <th>Peso</th>
          <th>Peso Tara</th>
        </tr>
      </thead>
      <tbody>
        {currentRecords.map((detail, index) => (
          <tr key={index}>
            <td>{detail.NombreCentroAcopio}</td>
            <td>{detail.Nombre_Usuario}</td>
            <td>{detail.CodProveedor}</td>
            <td>{detail.NombreProveedor}</td>
            <td>{detail.Observaciones || "N/A"}</td>
            <td>{detail.Temperatura} °F</td>
            <td>{detail.Peso}</td>
            <td>{detail.PesoTara}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Paginación */}
  <div className="d-flex justify-content-center mt-4">
    <nav>
      <ul className="pagination">
        {Array.from(
          {
            length: Math.ceil(
              recordsByCenterAndState1.flatMap((item) => item.details).length /
                registrosPorPagina
            ),
          },
          (_, i) => (
            <li key={i + 1} className="page-item">
              <button className="page-link" onClick={() => paginate(i + 1)}>
                {i + 1}
              </button>
            </li>
          )
        )}
      </ul>
    </nav>
  </div>
</div>
    </div>
  );
};

export default ListaCA;